export enum ReachTranslateLang {
	UNIVERSAL = 'universal',
	ENGLISH_GB = 'en-gb',
	SPANISH_SPAIN = 'es-es',
	FRENCH_FRANCE = 'fr-fr',
}
